import { useSnackbar } from "notistack";
import { useFormContext } from "../../../hooks/forms/useFormContext"
import { useCheckFormErrors } from "../../../hooks/forms/useCheckFormErrors";
import { useDispatch } from "react-redux";
import { saveUserSettings, setSettingsWindowVisible } from "../../../actions/userSettingsActions";
import { useViewport } from "../../../hooks/others/useViewport";
import { Button } from "@mui/material";
import { Save } from "@mui/icons-material";
import { 
    SETTINGS_WINDOW_FOOTER_FULL_WIDTH as fullWidthValues, 
    SETTINGS_WINDOW_FOOTER_LAYOUT_CLASS as layoutClassValues } 
from "../../../utils/constants/viewConstants";

const SavingButton = ({fullWidth}) => {
    const { data, errors } = useFormContext();
    const { enqueueSnackbar } = useSnackbar();
    const anyErrors = useCheckFormErrors(errors);
    const dispatch = useDispatch();

    const onClickSave = () => {
        if(anyErrors) return;

        dispatch(saveUserSettings(data));
        dispatch(setSettingsWindowVisible(false));
        enqueueSnackbar("User settings saved!", { variant: 'success' });
    }

    return (
        <Button
            fullWidth={fullWidth}
            variant="contained"
            disabled={anyErrors}
            onClick={onClickSave}
            endIcon={<Save />}
        >
            Save and close
        </Button>
    )
}

const SettingsFormFooter = () => {
    const fullWidth = useViewport(fullWidthValues);
    const layoutClass = useViewport(layoutClassValues);    

    return (
        <div className={`d-flex ${layoutClass} jc-end ai-center gap-1`}>
            <SavingButton fullWidth={fullWidth} />
        </div>
    )
}

export default SettingsFormFooter;